import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { string, number } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Additional component classes */
  className: string,
  /** Current `progress` value */
  loadingValue: number,
  /** Maximum `progress` value */
  loadingMax: number,
  /** Progress label */
  loadingLabel: string
};
const LoadingLinear = (props) => {
  const {
    className,
    prefix = "",
    loadingValue = 0,
    loadingMax = 100,
    loadingLabel,
    ...otherProps
  } = props;
  const baseClass = `${prefix}loading__linear`;
  const linearWrapperClasses = cx(
    `${baseClass}-wrapper`,
    className
  );
  const currentValue = loadingValue > loadingMax ? loadingMax : loadingValue;
  return /* @__PURE__ */ jsxs("span", { ...otherProps, className: linearWrapperClasses, children: [
    /* @__PURE__ */ jsx("label", { className: `${baseClass}-label`, children: loadingLabel }),
    /* @__PURE__ */ jsx(
      "progress",
      {
        className: `${baseClass}-progress`,
        value: currentValue,
        max: loadingMax,
        "aria-valuemin": "0",
        "aria-valuenow": currentValue,
        "aria-valuemax": loadingMax
      }
    )
  ] });
};
LoadingLinear.propTypes = propTypes;
var LoadingLinear_default = LoadingLinear;
export {
  LoadingLinear_default as default
};
